import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import TermsOfUseCheckbox from '../components/TermsOfUseCheckbox'
import TermsAndConditionsCheckbox from '../components/TermsAndConditionsCheckbox'
import FancySelectAdvancedRow from '../elements/FancySelectAdvancedRow'
import { SERVICE_VOIP } from '../constants'
import VoipUnlimited from '../components/VoipUnlimited'
import ComparePlans from '../components/ComparePlans/ComparePlans'

const options = {
    postUrl: '/api/postOrderUnlimitedCallPack',
    success: 'Success! Your unlimited call pack has been added to your VoIP service.'
}
const state = {
    planId: ''
}

class UnlimitedCallPackForm extends React.Component {
    componentDidMount () {
        this.selectPlanIfSingle()
    }

    componentDidUpdate (prevProps) {
        if (prevProps.plans !== this.props.plans) {
            this.selectPlanIfSingle()
        }
    }

    selectPlanIfSingle () {
        this.props.plans.forEach(plan => {
            if (this.isUnlimited(plan.monthly_price)) {
                this.props.setDynamicValues({
                    planId: plan.id
                })
            }
        })
    }

    handleChangePlan (id) {
        this.props.setDynamicValues({ planId: id })
    };

    isUnlimited (monthlyFee) {
        return parseFloat(monthlyFee) > 0
    };

    mapExistingPlanFields () {
        return {
            title: 'N/A',
            price: 0,
            html: ''
        }
    };

    mapApiPlanFields () {
        const plans = []
        this.props.plans.forEach(plan => {
            if (this.isUnlimited(plan.monthly_price)) {
                plans.push({
                    id: plan.id,
                    title: plan.description,
                    price: plan.monthly_price,
                    html: <VoipUnlimited />
                })
            }
        })

        return plans
    };

    render () {
        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                <FancySelectAdvancedRow
                    label='Select Home Phone number'
                    name='phone'
                    value={this.props.values.phone}
                    errors={this.props.errors}
                    options={this.props.numbers}
                    handleChange={this.props.setDynamicValues}
                />
                <div className='row mt-4 mb-3'>
                    <div className='col-12 col-lg-6 offset-lg-3'>
                        <ComparePlans
                            type={SERVICE_VOIP}
                            plans={this.mapApiPlanFields()}
                            existingPlan={this.mapExistingPlanFields()}
                            handleSelect={this.handleChangePlan.bind(this)}
                            selectedPlanId={parseInt(this.props.values.planId)}
                        />
                    </div>
                </div>
                <TermsOfUseCheckbox
                    errors={this.props.errors}
                    value={this.props.values.termsOfUse}
                    handleClick={value => this.props.setDynamicValues({ termsOfUse: value })}
                    cisUrl='https://files.exetel.com.au/cis/voip/CIS_Home_Phone.pdf'
                    termsUrl='https://files.exetel.com.au/terms/EXE0049-R-VoIP%20Terms%20FA.pdf'
                />
                <br />
                <TermsAndConditionsCheckbox
                    errors={this.props.errors}
                    value={this.props.values.termsAndConditions}
                    handleClick={value => this.props.setDynamicValues({ termsAndConditions: value })}
                    type={SERVICE_VOIP}
                />
                <br />

                {this.props.children}

                <div className='mt-4 w-100 text-center text-md-left'>
                    <Button title='Upgrade now' action={this.props.handleSubmit.bind(this)} />
                </div>
            </form>
        )
    }
}

export default FormHOC(UnlimitedCallPackForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/UnlimitedCallPackForm.js